import React, { FC } from 'react';

import { PageTitle, PageWrapper } from '../../../components';

export const CreateOrganizationGroup:FC = () => (
  <PageWrapper>
    <PageTitle title="Create a new group" />
  </PageWrapper>
);
